import { locationApi } from './endpoints';

export { locationApi } from './endpoints';

export const { useGetLocationQuery } = locationApi;
